module.exports = __webpack_public_path__ + "static/media/bg.d674e09a.png";